import { useT } from "../lib/i18n";

export function Differentiation() {
  const t = useT();
  const copy = t.differentiation;

  return (
    <section
      id="why"
      className="border-t border-margin dark:border-paper/10"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
            {copy.label}
          </p>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper">
            {copy.heading}
          </h2>
        </div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {copy.items.map((it) => (
            <article
              key={it.title}
              className="rounded-2xl border border-margin p-6 transition-colors hover:border-ink/30 dark:border-paper/10 dark:hover:border-paper/30"
            >
              <div className="font-mono text-xs text-ink/50 dark:text-paper/50">
                {it.tag}
              </div>
              <h3 className="mt-3 font-display text-xl font-semibold text-ink dark:text-paper">
                {it.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/70 dark:text-paper/70">
                {it.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
